import { useQuery } from '@tanstack/react-query';
import axios from '../../../services/axiosInstance';
import { GBP } from '../types/Listing';

export interface PostItem {
  name?: string;
  languageCode?: string;
  summary?: string;
  topicType?: string;
  state?: string;
  createTime?: string;
  updateTime?: string;
  searchUrl?: string;
  callToAction?: { actionType?: string; url?: string };
  media?: {
  name?: string;
  mediaFormat?: string;
  googleUrl?: string;
  thumbnailUrl?: string;  
}[];
  event?: {
    title?: string;
    schedule?: {
      startDate?: { year?: number; month?: number; day?: number };
      endDate?: { year?: number; month?: number; day?: number };
    };
  };
  offer?: { couponCode?: string; redeemOnlineUrl?: string };
}

function parseLocationParts(gbp: GBP | null): { accountId: string; locationId: string } | null {
  if (!gbp) return null;
  const fullName = gbp.locationId ?? '';
  const fullMatch = fullName.match(/^accounts\/([^/]+)\/locations\/([^/]+)$/);
  if (fullMatch) return { accountId: fullMatch[1], locationId: fullMatch[2] };
  const shortMatch = fullName.match(/^locations\/([^/]+)$/);
  if (shortMatch && gbp.accountName) {
    return { accountId: gbp.accountName.replace(/^accounts\//, ''), locationId: shortMatch[1] };
  }
  return null;
}

export const useLocationPosts = (
  gbp: GBP | null,
  enabled: boolean,
  subjectEmail: string  
) => {
  const parts = parseLocationParts(gbp);

  return useQuery<PostItem[]>({
    queryKey: ['gbp', 'posts', parts?.accountId, parts?.locationId, subjectEmail],

    queryFn: async () => {
      if (!parts) return [];

      const params = new URLSearchParams();
      params.append("subjectEmail", subjectEmail);

      const res = await axios.get(
        `/api/gbp/accounts/${parts.accountId}/locations/${parts.locationId}/posts?${params.toString()}`
      );

      return res.data?.posts ?? [];
    },

    enabled: enabled && !!parts && !!subjectEmail,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
};